import React, { useEffect, useState } from "react";
import { Card, Form, Select, Input, Button, Space, Divider, Descriptions, Tag, Typography } from "antd";
import { CheckCircleOutlined } from "@ant-design/icons";
import dateFormat from "dateformat";

const { Option } = Select;
const { Text } = Typography;

const OrderStatusTab = ({ selectedOrder, onUpdate, loading }) => {
  const [statusForm] = Form.useForm();
  const [submitting, setSubmitting] = useState(false);

  useEffect(() => {
    if (selectedOrder) {
      statusForm.setFieldsValue({
        order_status: selectedOrder.order_status || "",
        order_notes: selectedOrder.order_notes || "",
      });
    }
  }, [selectedOrder, statusForm]);

  const handleSubmit = async (values) => {
    try {
      setSubmitting(true);
      await onUpdate(values);
    } finally {
      setSubmitting(false);
    }
  };

  const orderStatusOptions = [
    { value: "Processing", color: "blue" },
    { value: "Already Called", color: "cyan" },
    { value: "Call Not Picked", color: "orange" },
    { value: "Waiting", color: "gold" },
    { value: "Confirmed", color: "green" },
    { value: "Cancelled", color: "red" },
    { value: "Others", color: "default" },
  ];

  return (
    <Card>
      <Form
        form={statusForm}
        layout="vertical"
        onFinish={handleSubmit}
        style={{ maxWidth: 600 }}
      >
        <Form.Item
          label="Order Status"
          name="order_status"
          rules={[{ required: true, message: "Please select order status" }]}
        >
          <Select placeholder="Select order status" size="large" loading={loading}>
            {orderStatusOptions.map((option) => (
              <Option key={option.value} value={option.value}>
                {option.value}
              </Option>
            ))}
          </Select>
        </Form.Item>

        <Form.Item label="Order Notes" name="order_notes">
          <Input.TextArea
            rows={4}
            placeholder="Add any notes or comments about this order..."
            maxLength={500}
            showCount
          />
        </Form.Item>

        <Form.Item>
          <Space>
            <Button
              type="primary"
              htmlType="submit"
              loading={submitting}
              icon={<CheckCircleOutlined />}
            >
              Update Status
            </Button>
            <Button onClick={() => statusForm.resetFields()} disabled={submitting}>
              Reset
            </Button>
          </Space>
        </Form.Item>
      </Form>

      {selectedOrder && (
        <>
          <Divider />
          <Descriptions title="Current Information" column={1} bordered size="small">
            <Descriptions.Item label="Order Status">
              {selectedOrder.order_status ? (
                <Tag color="blue">{selectedOrder.order_status}</Tag>
              ) : (
                <Text type="secondary">Not set</Text>
              )}
            </Descriptions.Item>
            <Descriptions.Item label="Order Notes">
              {selectedOrder.order_notes ? (
                <Input.TextArea
                  value={selectedOrder.order_notes}
                  readOnly
                  autoSize={{ minRows: 2, maxRows: 6 }}
                  style={{
                    border: "none",
                    resize: "none",
                  }}
                />
              ) : (
                <Text type="secondary">No notes</Text>
              )}
            </Descriptions.Item>
            <Descriptions.Item label="Last Updated">
              {selectedOrder.updated_at
                ? dateFormat(selectedOrder.updated_at, "dd-mm-yyyy hh:MM TT")
                : "N/A"}
            </Descriptions.Item>
          </Descriptions>
        </>
      )}
    </Card>
  );
};

export default OrderStatusTab;